import R from 'ramda';
import $ from 'jquery';
import React from 'react';
import Promise from 'bluebird';
import Modal from 'react-bootstrap/lib/Modal';
import Alert from 'react-bootstrap/lib/Alert';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import Spinner from '../../modules/Spinner.jsx';
import Table from '../users/Table.jsx';
import CreateLicenseRequestForm from './CreateLicenseRequestForm.jsx';
import EditLicenseRequestForm from './EditLicenseRequestForm.jsx';
import Pagination from 'react-bootstrap/lib/Pagination';

const pageSize = 20;
const columns = [
  { id: 'id', label: 'ID', maxWidth: 1 },
  { id: 'name', label: 'Nombre', maxWidth: 4 },
  { id: 'username', label: 'Correo', maxWidth: 4 },
  { id: 'licenseRequest', label: 'Lic. Pedidas', maxWidth: 1 },
];

export default class LicenseRequests extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      creatingLicenseRequest: false,
      edittingLicenseRequest: false,
      sortColumn: 'id',
      sortOrder: 'asc',
      selectedRow: null,
      page: 0,
    };
  }
  componentDidMount() {
    this.fetchLicenseRequests(this.props.resourceUrl);
  }
  render() {
    if (!this.state.licenseRequestsResource && this.state.loadingLicenseRequests) {
      return <Spinner />;
    }

    if (!this.state.licenseRequestsResource && !this.state.loadingLicenseRequests) {
      return <div>{this.state.errorMessage}</div>;
    }

    const resource = this.state.licenseRequestsResource;
    const selectedIndex = this.state.selectedRow ? this.state.selectedRow.index : null;
    const data = this.state.loadingLicenseRequests ? [] : resource.licenseRequests;
    
    return (
      <div>
        <button type='button' className='btn btn-success' style={{ display: 'none', marginRight: '10px' }} onClick={this.handleOpenCreateLicenseRequestModal}>Crear Petición</button>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info'  style={{ marginRight: '10px' }} onClick={this.handleOpenDeleteLicenseRequestModal}>Eliminar Peticion</button>
        </If>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info'  style={{ marginRight: '10px' }} onClick={this.handleOpenAcceptLicenseRequestModal}>Aceptar Peticion</button>
        </If>
        <If condition={this.state.selectedRow !== null}>
          <button type='button' className='btn btn-info'  style={{ marginRight: '10px' }} onClick={this.handleOpenEditLicenseRequestModal}>Editar y Aceptar Peticion</button>
        </If>
        <If condition={this.state.licenseRequest} >
          {this.renderCreateLicenseRequestModal()}
        </If>
        <If condition={this.state.deleteLicenseRequest} >
          {this.renderDeleteLicenseRequestModal()}
        </If>
        <If condition={this.state.acceptLicenseRequest} >
          {this.renderAcceptLicenseRequestModal()}
        </If>
        <If condition={this.state.editLicenseRequest} >
          {this.renderEditLicenseRequestModal()}
        </If>

        <Table 
          columns={columns} 
          sort={{ column: this.state.sortColumn, order: this.state.sortOrder }}
          data={data} 
          selectedIndex={selectedIndex} 
          onSort={this.handleSortChange}
          onRowClick={(event) => this.setState({ selectedRow: event })} 
          onRowDoubleClick={() => {}}
        />
        <If condition={resource.total > pageSize}>
          <center>
            <Pagination 
              prev={this.state.page !== 0} 
              next={(this.state.page + 1) * pageSize <= resource.total} 
              first={this.state.page !== 0} 
              last={(this.state.page + 1) * pageSize <= resource.total} 
              bsSize="medium" 
              maxButtons={10} 
              items={Math.ceil(resource.total / pageSize)} 
              activePage={this.state.page + 1} 
              onSelect={this.handlePageChange} />
          </center>
        </If>
      </div>
    );
  }

  handleSortChange({ column, order }) {
    const prevColumn = this.state.sortColumn, prevOrder = this.state.sortOrder;
    this.setState({ sortColumn: column, sortOrder: order });
    const url = this.state.licenseRequestsResource._rels.sort.replace('{sort}', column).replace('{order}', order);
    this.fetchLicenseRequests(url, this.state.page)
    .catch(() => this.setState({ sortColumn: prevColumn, sortOrder: prevOrder }))
  }

  handlePageChange(eventKey) {
    const page = eventKey - 1;
    this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.getPage.replace('{pageNum}', page), page);
  }

  fetchLicenseRequests(url, page = 0) {
    if (this.state.loadingLicenseRequests) {
      return Promise.reject('Already fetching licenseRequests.');
    }
    const prevPage = this.state.page;
    this.setState({ loadingLicenseRequests: true, selectedRow: null, page });
    
    return Promise.resolve($.ajax({ url }))
    .then((licenseRequestsResource) => this.setState({ licenseRequestsResource }))
    .catch(() => this.setState({ page: prevPage, errorMessage: 'Hubo un error al cargar las peticiones.' }))
    .finally(() => this.setState({ loadingLicenseRequests: false }));
  }

  handleOpenCreateLicenseRequestModal() {
    this.setState({ licenseRequest: { username: '', licenseNum: 1 }});
  }
  
  handleOpenEditLicenseRequestModal() {
    this.setState({ editLicenseRequest: this.state.selectedRow.row });
  }

  handleOpenDeleteLicenseRequestModal() {
    this.setState({ deleteLicenseRequest: this.state.selectedRow.row });
  }

  handleOpenAcceptLicenseRequestModal() {
    this.setState({ acceptLicenseRequest: this.state.selectedRow.row });
  }

  handleAcceptLicenseRequest(event) {
    event.preventDefault();
    this.setState({ acceptingLicenseRequest: true });
    const url = this.props.resourceUrl + "/accept/";

    return Promise.resolve($.ajax({
      url: url,
      data: this.state.acceptLicenseRequest,
      method: 'POST',
    })).then(() => {
      this.setState({ acceptLicenseRequest: null });
      this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.self, this.state.page);
    }).finally(() => this.setState({ acceptingLicenseRequest: false }));
  }
  
  handleCreateLicenseRequest(event) {
    event.preventDefault();
    this.setState({ creatingLicenseRequest: true });

    return Promise.resolve($.ajax({
      url: this.props.resourceUrl,
      method: 'POST',
      data: this.state.licenseRequest
    })).then(() => {
      this.setState({ licenseRequest: null, modalErrorMessage: null , });
      this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.self, this.state.page);
    }).catch(() => this.setState({ modalErrorMessage: 'Hubo un error al crear la petición.' }))
    .finally(() => this.setState({ creatingLicenseRequest: false }));
  }

  handleEditLicenseRequest(event) {
    event.preventDefault();
    this.setState({ edittingLicenseRequest: true });
    const url = this.props.resourceUrl + "/accept/";
    
    return Promise.resolve($.ajax({
      url: url,
      data: this.state.editLicenseRequest,
      method: 'POST'
    })).then(() => {
      this.setState({ editLicenseRequest: null, modalErrorMessage: null });
      this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.self, this.state.page);
    }).catch(() => this.setState({ modalErrorMessage: 'Hubo un error al crear la petición.' }))
    .finally(() => this.setState({ edittingLicenseRequest: false }));
  }

  handleDeleteLicenseRequest(event) {
    event.preventDefault();
    this.setState({ deletingLicenseRequest: true });
    const url = this.props.resourceUrl + "/delete/";

    return Promise.resolve($.ajax({
      url: url,
      data: this.state.deleteLicenseRequest,
      method: 'POST',
    })).then(() => {
      this.setState({ deleteLicenseRequest: null });
      this.fetchLicenseRequests(this.state.licenseRequestsResource._rels.self, this.state.page);
    }).finally(() => this.setState({ deletingLicenseRequest: false }));
  }

  renderDeleteLicenseRequestModal() {
    const closeModal = () => this.setState({ deleteLicenseRequest: null })

    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de querer eliminar la petición de {this.state.deleteLicenseRequest.name}?
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleDeleteLicenseRequest} disabled={this.state.deletingLicenseRequest}>Eliminar</button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderCreateLicenseRequestModal() {
    const closeModal = () => this.setState({ licenseRequest: null, modalErrorMessage: null })
    const validLicenseRequestForm = () => R.is(Object, this.state.licenseRequest) && validations.email(this.state.licenseRequest.username);
    
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <If condition={this.state.modalErrorMessage} >
            <Alert bsStyle="danger" onDismiss={() => this.setState({ modalErrorMessage: null })}>{this.state.modalErrorMessage}</Alert>
          </If>
          <CreateLicenseRequestForm value={this.state.licenseRequest} onChange={(formChange) => this.setState({ licenseRequest: formChange})} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleCreateLicenseRequest} disabled={!validLicenseRequestForm() || this.state.creatingLicenseRequest}>Crear</button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderAcceptLicenseRequestModal() {
    const closeModal = () => this.setState({ acceptLicenseRequest: null })
    
    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Aceptar Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de querer aceptar la petición de {this.state.acceptLicenseRequest.name}?
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleAcceptLicenseRequest} disabled={this.state.acceptingLicenseRequest}>Aceptar</button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderEditLicenseRequestModal() {
    const closeModal = () => this.setState({ editLicenseRequest: null, modalErrorMessage: null })
    const validLicenseRequestForm = () => R.is(Object, this.state.editLicenseRequest) && validations.email(this.state.editLicenseRequest.username);

    return (
      <Modal show={true} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar y Acpetar Petición</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <If condition={this.state.modalErrorMessage} >
            <Alert bsStyle="danger" onDismiss={() => this.setState({ modalErrorMessage: null })}>{this.state.modalErrorMessage}</Alert>
          </If>
          <EditLicenseRequestForm value={this.state.editLicenseRequest} onChange={(formChange) => this.setState({ editLicenseRequest: formChange})} />
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-danger' onClick={closeModal}>Cancelar</button>
          <button type='submit' className='btn btn-success' onClick={this.handleEditLicenseRequest} disabled={!validLicenseRequestForm() || this.state.edittingLicenseRequest}>Aceptar</button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/licenses/licenseRequests.jsx